import {Injectable, Inject} from '@angular/core';
import {Response, ResponseContentType} from '@angular/http';
import { DocumentMaster } from 'app/modules/document/models/document-master';
import {Observable} from 'rxjs/Rx';
import {TokenHttp} from '../../core/services/token-http';
import { DocumentDetail } from '../models/document-detail';

@Injectable()
export class DocumentService {

  constructor(private http: TokenHttp,
              @Inject('ApplicationConfig') private config: any) { }

  details(id: number): Observable<DocumentDetail> {
    return this.http.get(this.config.apiEndpoint + '/api/irarsites/details?id=' + id)
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json() || 'Server error'));
  }

  upsert(model: DocumentDetail): Observable<boolean> {
    return this.http.post(this.config.apiEndpoint + '/api/irarsites/upsert', model)
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json() || 'Server error'));
  }

  glennDale(): Observable<DocumentMaster[]> {
    return this.http.get(this.config.apiEndpoint + '/api/irarsites/retrieveglenndale')
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json() || 'Server error'));
  }

}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/services/document.ts